import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import DrupalAccessTokenApi from "../../../js/csf/DrupalAccessTokenApi";
import { startLoadingSpinner, stopLoadingSpinner } from '../../csf-ufc-pivotal/includes/utils';
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import CsfFournisseurPagination from "../includes/csf-fournisseur-pagination";
import {CsfFournisseurListFormateursTable} from "./csf-fournisseur-gestion-list-table";
import {CsfFournisseurListModal} from "./csf-fournisseur-gestion-list-modal";
import {handleClickLinks, buildSearchConditionsContains, clearSearchBtn} from '../includes/utils';
import PropTypes from "prop-types";

export function CsfPivotalFournisseurFormateursListing({apiUrl, apiEnv, urlGestion, urlFormationDetailList}) {

  const [accessToken, setAccessToken] = useState('');
  const [trainersList, setTrainersList] = useState([]);
  const [inputSearchValue, setInputSearchValue] = useState('');
  const [isSearch, setIsSearch] = useState(false);
  const [startRow, setStartRow] = useState(1);
  const [total, setTotal] = useState(0);
  const offset = 5;

  /*
  * On components mounts fetch the user access token only once.
  * */
  useEffect(() => {
    startLoadingSpinner();
    fetchAccessToken();
  }, []);

  /*
  * When the accessToken is fetched and state is updates, get the formations lists.
  * */
  useEffect(() => {
    if (accessToken) {
      getTrainersList();
      setIsSearch(false);
    }
  }, [accessToken, startRow, isSearch]);

  /*
  * Method to call drupal api to get the access token of the session.
  * */
  function fetchAccessToken() {
    const drupalAccessTokenApi = new DrupalAccessTokenApi();
    drupalAccessTokenApi.fetchPostRequest('fournisseur')
      .then(response => {
        if (response?.api_access_token) {
          setAccessToken(response.api_access_token);
        } else {
          stopLoadingSpinner();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to fetch the trainers lists.
  * */
  function getTrainersList() {
    const requestData = buildMainBodyDataResquest();
    const pivotalSearchApi = new PivotalSearchApi(apiUrl, apiEnv, accessToken);
    pivotalSearchApi.callSearchEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        console.log(response);
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          setTrainersList(response.payload.data.rows);
          setTotal(response.payload.data.searchTotal);
          setIsSearch(false);
        }
        stopLoadingSpinner();
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method that handle the value changed on the search bar.
  * */
  function handleSearchChange(event) {
    const value = event.target.value;
    setInputSearchValue(value);
  }

  /*
  * Method that handle the click on the search Btn of the search bar
  * */
  function handleSearchBtn(event){
    if (event.key === 'Enter' || event.type === "click") {
      setIsSearch(true);
      setStartRow(1);
    }
  }

  /*
  * Method to build the body array for the request
  * */
  function buildMainBodyDataResquest() {
    let requestData = {
      maxRows: offset,
      startRow: startRow,
      ParameterValues: [""],
      matchCondition: 1,
      search: 'CSF_EP_UxContactLists_REST',
      searchResultsList: 'CSF_EP_ContactLists_SRL'
    };

    let searchConditions = buildSearchConditionsContains(inputSearchValue, ["List_Name"]);

   if (searchConditions.length > 0) {
     requestData.conditions = searchConditions;
   }

    return requestData;
  }

  /*
  * Method that trigger an empty search when X button is clicked in the search field.
  * */
  function retriggerEmptySearch(){
    setInputSearchValue("");
    setIsSearch(true);
    setStartRow(1);
  }

  return (
    <main className="fournisseur fournisseur-gestion-list">
      <div className="header-wrapper">
        <h1>{window.Drupal.t('fournisseur.trainers.listing.page.title')}</h1>
      </div>

      <div className="primary">
        <div className="space-between-wrapper">
          <h2>{window.Drupal.t('fournisseur.trainers.listing.table.title')}</h2>
        </div>

        <div className="inner-wrapper">
          <div className="search-container">
            <label htmlFor="listTableSearch" className="sr-only">{window.Drupal.t('search.label')}</label>
            <input type="search" id="listTableSearch" value={inputSearchValue} onChange={handleSearchChange} onKeyDown={handleSearchBtn}
                  placeholder={window.Drupal.t('fournisseur.search.placeholder')}/>
            <button className="search-close-icon btn-link" aria-label={window.Drupal.t('fournisseur.search.clear.label')}
                  onClick={(e) => {
                    clearSearchBtn(e, setInputSearchValue)
                    retriggerEmptySearch();
                  }}
            >
              <i className="icon icon-remove"></i>
            </button>
            <button className="button btn-outlined search-icon" onClick={handleSearchBtn}
              title={window.Drupal.t('search.label')} aria-label={window.Drupal.t('search.label')}>
              <i className="icon icon-search-2"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <CsfFournisseurListFormateursTable
            trainersList={trainersList}
            urlFormationDetailList={urlFormationDetailList}
          />

          <div className="pagination-wrapper space-between-wrapper smaller-wrapper">
            <CsfFournisseurPagination
              startRow={startRow}
              offset={offset}
              total={total}
              setStartRowFunction={setStartRow}
            />

            <div className="buttons-wrapper">
              <button onClick={() => handleClickLinks(urlGestion)} className="button btn-outlined btn-larger">
                {window.Drupal.t('fournisseur.previous.btn')}
              </button>

              <button className="button btn-with-icon btn-larger" type="button" data-toggle="modal" data-target="#createTrainersList">
                <i className="icon icon-csf-plus"><span className="d-none">&nbsp;</span></i>
                {window.Drupal.t('fournisseur.trainers.listing.create.btn')}
              </button>
            </div>

            <CsfFournisseurListModal
              accessToken={accessToken}
              apiUrl={apiUrl}
              apiEnv={apiEnv}
              listId=""
            />

          </div>
        </div>
      </div>
    </main>
  );
}

window.addEventListener('DOMContentLoaded', () => {
  const domNode = document.getElementById('CsfPivotalFournisseurFormateursListing');
  if (domNode !== null) {
    const root = createRoot(domNode);

    const apiUrl = domNode.getAttribute("data-api-url");
    const apiEnv = domNode.getAttribute("data-api-env");
    const urlGestion = domNode.getAttribute("data-api-gestion");
    const urlFormationDetailList = domNode.getAttribute("data-api-formation-list-detail");

    root.render(<CsfPivotalFournisseurFormateursListing
      apiUrl={apiUrl}
      apiEnv={apiEnv}
      urlGestion={urlGestion}
      urlFormationDetailList={urlFormationDetailList}
    />);
  }
});

CsfPivotalFournisseurFormateursListing.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  urlGestion: PropTypes.string,
  urlFormationDetailList: PropTypes.string,
};
